import eye from "../../assets/brand/eye.png"
import {
  CButton,
  CCol,
  CFormInput,
  CInputGroup,
  CRow,
  CSpinner,
} from "@coreui/react";
import { useCallback, useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { getOwnerSearchHorse } from "src/services/horseServices/horseService";
import ShowHorseDetailsModal from "./ShowHorseDetailsModal";
const emptyValueComponent = () => {
  return <div>-</div>;
};

let firstRender = true;
let isOwnerSearchPage = true;

const OwnerSearchHorse = () => {
  const isAdmin = useSelector((state) => state.auth.isAdmin);
  const [isLoading, setLoading] = useState(false);
  const [horseData, setHorseData] = useState({});
  const [apiParams, setApiParams] = useState({
    pageNo: 1,
    itemsPerPage: 10,
    query: "",
  });
  const [horseDetailState, setHorseDetailState] = useState(false);
  const [horseDetails, setHorseDetails] = useState({});
  const [horseModalState, setHorseModalState] = useState(false);
  const [horseModalData, setHorseModalData] = useState({});

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await getOwnerSearchHorse(apiParams);
      setHorseData(res);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!firstRender && apiParams.query) {
      fetchData();
    }
    if (!firstRender && !apiParams.query) {
      setHorseData({});
    }
    return () => {
      firstRender = false;
    };
  }, [apiParams]);

  const handleSearch = (value) => {
    setApiParams((prevState) => ({
      ...prevState,
      query: value,
      pageNo: 1,
    }));
  };

  const columns = [
    {
      name: "Horse Name",
      selector: (row) => (row.name ? row.name : emptyValueComponent()),
    },
    {
      name: "Registration Number",
      minWidth: "180px",
      selector: (row) =>
        row.registrationNum ? row.registrationNum : emptyValueComponent(),
    },
    {
      name: "Sex",
      selector: (row) => (row.sex ? row.sex : emptyValueComponent()),
    },
    {
      name: "Color",
      selector: (row) => (row.color ? row.color : emptyValueComponent()),
    },
    {
      name: "Owner Name",
      selector: (row) =>
        row.ownerName ? row.ownerName : emptyValueComponent(),
    },
    {
      name: "View",
      omit: false,
      selector: (row) => {
        return (
          <img
            src={eye}
            alt="View"
            role="button"
            onClick={() => onNameClick(row)}
            className="text-secondary"
            style={{ width: "20px" }}
          />
        );
      },
    },
  ];

  const onAddHorseClick = useCallback(() => {
    setHorseModalData({});
    setHorseModalState(true);
  }, []);

  const onNameClick = useCallback((id) => {
    setHorseDetails(id);
    setHorseDetailState(true);
  }, []);

  const changePage = (e) => {
    setApiParams({ ...apiParams, pageNo: e });
  };

  const changeItemPerPage = (items) => {
    setApiParams({ ...apiParams, pageNo: 1, itemsPerPage: items });
  };

  return (
    <div>
      <div className="d-flex mb-3">
        {!isAdmin ? (
          ""
        ) : (
          <CButton className="ms-auto" color="dark" onClick={onAddHorseClick}>
            Add New Horse
          </CButton>
        )}
      </div>
      <div className="rounded overflow-auto">
        <DataTable
          subHeader
          subHeaderComponent={
            <SubHeaderComponent
              handleSearch={handleSearch}
            />
          }
          columns={columns}
          data={horseData.data || []}
          progressPending={isLoading}
          progressComponent={<CSpinner color="dark" className="m-5" />}
          pagination={true}
          paginationServer
          responsive={true}
          onChangeRowsPerPage={(e) => changeItemPerPage(e)}
          paginationDefaultPage={apiParams.pageNo}
          onChangePage={(e) => changePage(e)}
          pageNo={apiParams.pageNo}
          paginationPerPage={apiParams.itemsPerPage}
          paginationTotalRows={horseData?.pagination?.totalItems}
          paginationRowsPerPageOptions={[10, 25, 50, 100]}
          noDataComponent={
            !apiParams.query ? (
              <div className="mb-4">Search to get horse list</div>
            ) : (
              <div className="mb-4">There are no records to display</div>
            )
          }
        />
      </div>

      <ShowHorseDetailsModal
        modalState={horseDetailState}
        setModalState={setHorseDetailState}
        modalData={horseDetails}
        isOwnerSearchPage={isOwnerSearchPage}
      />
    </div>
  );
};

export default OwnerSearchHorse;

const SubHeaderComponent = ({ handleSearch }) => {
  const [searchValue, setSearchValue] = useState("");

  const onSearch = () => {
    handleSearch(searchValue.trim());
  };

  const handleChange = (value) => {
    setSearchValue(value);
    if (value === "") {
      handleSearch("");
    }
  };
  // const searchRef = useRef();

  // const onSearch = () => {
  //   handleSearch(searchRef?.current.value?.trim());
  // };

  return (
    <CRow>
      <CCol>
        <CInputGroup className="mt-3 mb-3">
          <CFormInput
            placeholder="Search here..."
            type="search"
            id="searchBar"
            aria-label="Search Bar"
            aria-describedby="basic-addon2"
            // ref={searchRef}
            onChange={(e) => handleChange(e.target.value)}
          />
          <CButton color="dark" onClick={onSearch}>
            Search
          </CButton>
        </CInputGroup>
      </CCol>
    </CRow>
  );
};
